import http from "../http-common";

class CycleService {
  getAll() {
    return http.get("/cycles");
  }

  get(id) {
    return http.get(`/cycles/${id}`);
  }

  create(data) {
    return http.post("/cycles", data);
  }

  update(id, data) {
    return http.put(`/cycles/${id}`, data);
  }

  delete(id) {
    return http.delete(`/cycles/${id}`);
  }

  getTrashed() {
    return http.get("/cycles/trashed/list");
  }

  restore(id) {
    return http.post(`/cycles/${id}/restore`);
  }
}

export default new CycleService();
